import {ClientProfileComponent} from "./profile";
import {DICTIONARY_COMPONENTS, DICTIONARY_SERVICES} from './dictionary';
import {FilesDownloadComponent} from './file/download/files.download.component';

/**
 * Package exports high level components, that represents system entities.
 * */

export const CUSTOM_COMPONENTS = [
    ClientProfileComponent,
    FilesDownloadComponent,
    ...DICTIONARY_COMPONENTS
];

export const CUSTOM_PROVIDERS = [
    ...DICTIONARY_SERVICES
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/components/index.ts